'use strict';
import * as $j_java$002elang$002e$002dEnum from "./java.lang.-Enum.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $ct_Ljava_time_format_SignStyle__T__I__T__I__($thiz, name, ordinal, _$name, _$ordinal) {
  $thiz.jV = ordinal;
  $j_java$002elang$002e$002dEnum.$ct_jl_Enum__T__I__($thiz, _$name, _$ordinal);
  return $thiz;
}
export { $ct_Ljava_time_format_SignStyle__T__I__T__I__ as $ct_Ljava_time_format_SignStyle__T__I__T__I__ };
/** @constructor */
function $c_Ljava_time_format_SignStyle() {
  this.q = null;
  this.M = 0;
  this.jV = 0;
}
export { $c_Ljava_time_format_SignStyle as $c_Ljava_time_format_SignStyle };
$p = $c_Ljava_time_format_SignStyle.prototype = new $j_java$002elang$002e$002dEnum.$h_jl_Enum();
$p.constructor = $c_Ljava_time_format_SignStyle;
/** @constructor */
function $h_Ljava_time_format_SignStyle() {
}
export { $h_Ljava_time_format_SignStyle as $h_Ljava_time_format_SignStyle };
$h_Ljava_time_format_SignStyle.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.PQ = (function(positive, strict, fixedWidth) {
  switch (this.jV) {
    case 0: {
      return ((!positive) || (!strict));
      break;
    }
    case 1:
    case 4: {
      return true;
      break;
    }
    default: {
      return ((!strict) && (!fixedWidth));
    }
  }
});
